export class ProgressModel {
  tasks: ProgressItemModel;
  tasks_direct: ProgressItemModel; // tslint:disable-line:variable-name
  elearning: ProgressItemModel;
  resources: ProgressItemModel;
  skillschecker: ProgressItemModel;
  coaching: ProgressItemModel;
  coach_requests: ProgressItemModel;
  coach_appointments: ProgressItemModel;

  constructor() {
    this.tasks = new ProgressItemModel();
    this.tasks_direct = new ProgressItemModel();
    this.elearning = new ProgressItemModel();
    this.resources = new ProgressItemModel();
    this.skillschecker = new ProgressItemModel();
    this.coaching = new ProgressItemModel();
    this.coach_requests = new ProgressItemModel();
    this.coach_appointments = new ProgressItemModel();
  }
}

export class ProgressItemModel {
  total: number = 0;
  completed: number = 0;
  attempted: number = 0;
  incompleted: number = 0;
  amount: number = 0;
  average: string = '0';
}
